// ─────────────────────────────────────────────────────────────────────────────
// THE ONE PLACE THAT DECIDES WHETHER GOOGLE ADS IS IN THE DOCUMENT.
//
// 🔑 IT RENDERS NOTHING. It exists to run on every navigation, because in a
// single-page app the route changing is the only event that corresponds to
// "a new page" — and the tag has to be reconsidered then, in both directions.
//
// ⚠️ IT IS NOT MOUNTED ON DoorlyDesk. AppRoutes returns a separate tree for
// desk.godoorly.com and this is deliberately absent from it: staff routes are
// authenticated end to end, so there is no path through that tree on which the
// tag would be allowed, and mounting it there would only create one.
// ─────────────────────────────────────────────────────────────────────────────
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { syncMarketingTag } from '../utils/marketingTag';

export default function MarketingTag() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    syncMarketingTag(pathname, search);
  }, [pathname, search]);
  return null;
}
